export default __webpack_public_path__ + "static/media/btn_selectall.8ee0737e.png";